export default class DomElement {

    /**
     * Recherche un élément parent
     * @param HTMLElement element
     * @param string selector Sélecteur du parent à retourner
     * @return self
     */
    static getParent(element, selector = null) {

        let parent = element;

        do {
            if (selector && parent.matches(selector)) {
                return parent;
            }
            parent = parent.parentElement /*|| parent.parentNode*/;
            if(! selector && parent) {
                return parent;
            }
        } while (parent !== null);
        return null;
    };

    /**
     * Retourne les enfants de l'élément en paramètre
     * @param HTMLElment element
     * @param bool recursive Vrai si on souhaite récupérer tous les descendants
     * @return array
     */
    static getChildren(element, recursive = false) {

        let children = [];

        for (const child of element.children) {
            children.push(child);

            if(recursive) {
                children = [
                    ...children,
                    ...DomElement.getChildren(child, recursive)
                ]
            }
        }

        return children;
    }

    /**
     * Retourne si l'élément en paramètre est visible (n'est pas en display none)
     * @param HTMLElement element
     * @return boolean
     */
    static isVisible(element) {
        const display = (getComputedStyle(element).display ?? null);
        return (display !== 'none');
    };
}
